function defineLoopingSlider() {
  if (!customElements.get('looping-slider')) {
    customElements.define('looping-slider', class LoopingSlider extends SliderComponent {
        constructor() {
            super();
            this.enableSliderLooping = true;
            if (this.prevButton) this.prevButton.removeAttribute('disabled');
            if (this.nextButton) this.nextButton.removeAttribute('disabled');
        }

        onButtonClick(event) {
            event.preventDefault();
            const step = event.currentTarget.dataset.step || 1;
            const isNext = event.currentTarget.name === 'next';
            const isAtEnd = this.currentPage >= this.totalPages;
            const isAtStart = this.currentPage <= 1;

            if (isNext && isAtEnd) {
                this.setSlidePosition(0);
            } else if (!isNext && isAtStart) {
                this.setSlidePosition(this.slider.scrollWidth);
            } else {
                this.slideScrollPosition = isNext
                ? this.slider.scrollLeft + step * this.sliderItemOffset
                : this.slider.scrollLeft - step * this.sliderItemOffset;
                this.setSlidePosition(this.slideScrollPosition);
            }
        }
    });
  }
}

if (customElements.get('slider-component')) {
  defineLoopingSlider();
} else {
  customElements.whenDefined('slider-component').then(defineLoopingSlider);
}